<template>
	<div class="card">
		<div class="card-header">
			<h3>Users</h3>
		</div>
		<div class="card-body">
			<div class="d-flex justify-content-between mb-4">
				<div class="dropdown">
				  	<button class="btn btn-outline-secondary dropdown-toggle" type="button" id="statusFilterButton" data-bs-toggle="dropdown" aria-expanded="false">
				    	User Status ({{ statusFilters.length }})
				  	</button>
				  	<ul class="dropdown-menu" aria-labelledby="statusFilterButton">
						<li class="dropdown-item">
							<div class="form-check">
								<label class="form-check-label" for="checkboxActive">
									<input class="form-check-input" type="checkbox" value="Active" v-model="statusFilters" id="checkboxActive">
								    Active
							  	</label>
							</div>
						</li>
						<li class="dropdown-item">
							<div class="form-check">
								<label class="form-check-label" for="checkboxInactive">
							  		<input class="form-check-input" type="checkbox" value="Inactive" v-model="statusFilters" id="checkboxInactive">
								    Inactive
							  	</label>
							</div>
						</li>
					</ul>
				</div>

				<a href="/users/create" class="btn btn-primary pull-right">New User</a>
			</div>

			<table class="table table-striped">
				<thead>
					<tr>
						<th scope="col">Name</th>
						<th scope="col">Onyen</th>
						<th scope="col">Email</th>
						<th scope="col">Role</th>
						<th scope="col">&nbsp;</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="user in orderedUsers"  :key="user.id">
						<td>{{ user.name }} <span v-if="!user.is_active" class="badge bg-secondary badge-small">Inactive</span></td>
						<td>{{ user.onyen }}</td>
						<td>{{ user.email }}</td>
						<td>{{ user.roles.join(', ') }}</td>
						<td class="text-right">
							<a :href="'users/'+user.id+'/edit'" class="btn btn-secondary btn-sm">edit</a>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script setup>
	import { ref, computed, unref } from 'vue'

	const props = defineProps({ users: Array });
	const sort = ref({ field: 'status', dir: 'asc' });
	const statusFilters = ref(['Active']);

	const orderedUsers = computed(() => {
		const ordered = unref(props.users)
			.slice()
			.filter((user) => {
	    let userStatus = user.is_active ? 'Active' : 'Inactive';
	    return unref(statusFilters).includes(userStatus);
	}).map(function (user) {
			return {
				id: user.id,
				name: [user.first_name,user.last_name].join(' '),
				onyen: user.onyen,
				email: user.email,
				roles: user.roles?.map(role => role.name) || [],
				is_active: user.is_active,
			}
		});

		return ordered;
	});
</script>